<div class="pageheader">
    <div class="page-title">
        <h1>Partner Tags</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Settings_Action_Settings_ShowLog'" [title]="'Tags log'">
                <app-change-log-link-entity type="Tag"></app-change-log-link-entity>
            </app-change-log-link>
        </div>
    </div>
</div>

<!-- <div class="row">
    <div class="col-sm-12"> -->
        <dx-data-grid biz-grid
                      [selection]='{ mode: "none" }'
                      [showIsLoading]="isLoading"
                      [dataSource]='tags'
                      (onInitNewRow)="initNewRow($event)"
                      (onRowInserting)="createTag($event)"
                      (onRowUpdating)="updateTag($event)"
                      (onRowRemoving)="deleteTag($event)">
            <dxo-editing mode="row"
                         [allowUpdating]="allowUpdating"
                         [allowAdding]="allowAdding"
                         [allowDeleting]="allowDeleting">
            </dxo-editing>

            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

            <dxi-column dataField="Name" caption="Name" [validationRules]="[{ type: 'required' }]" dataType="string" sortOrder="asc"></dxi-column>
            <dxi-column dataField="CreatedDate" caption="Created" [allowEditing]="false" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>

            <dxi-column type="buttons">
                <dxi-button name="edit"></dxi-button>
                <dxi-button name="delete"></dxi-button>
                <dxi-button text="Show Log"
                            template="logTemplate"
                            [visible]="allowShowLog">
                </dxi-button>
            </dxi-column>

            <ng-container *dxTemplate="let cell of 'logTemplate'">
                <app-change-log-link *bizPermissionRequired="'Settings_Action_Settings_ShowLog'" [title]="'Logs for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
                    <app-change-log-link-entity type="Tag" [id]="cell.data.Id"></app-change-log-link-entity>
                </app-change-log-link>
            </ng-container>
        </dx-data-grid>
    <!-- </div>
</div> -->
